{
	"asset":{
		"generator":"Khronos glTF Blender I/O v4.1.63",
		"version":"2.0"
	},
	"scene":0,
	"scenes":[
		{
			"name":"Scene",
			"nodes":[
				0,
				1
			]
		}
	],
	"nodes":[
		{
			"mesh":0,
			"name":"Cube.121",
			"scale":[
				1.1018846035003662,
				0.457942396402359,
				1.3445651531219482
			],
			"translation":[
				0,
				3.6763336658477783,
				0
			]
		},
		{
			"mesh":1,
			"name":"head.030",
			"rotation":[
				0,
				0,
				-0.1302284598350525,
				0.9914840459823608
			],
			"scale":[
				2.052353620529175,
				1.9658100605010986,
				2.190054416656494
			],
			"translation":[
				0.5338709354400635,
				5.623793125152588,
				0
			]
		}
	],
	"materials":[
		{
			"doubleSided":true,
			"name":"Material.049",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.8110413551330566,
					0.6465651988983154,
					0.4139544367790222,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.050",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.32843300700187683,
					0.003659324487671256,
					0.00805484876036644,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.048",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.7697931528091431,
					0.8131840825080872,
					0.767202615737915,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		}
	],
	"meshes":[
		{
			"name":"Cube.024",
			"primitives":[
				{
					"attributes":{
						"POSITION":0,
						"NORMAL":1,
						"TEXCOORD_0":2
					},
					"indices":3,
					"material":0
				}
			]
		},
		{
			"name":"Cube.028",
			"primitives":[
				{
					"attributes":{
						"POSITION":4,
						"NORMAL":5,
						"TEXCOORD_0":6
					},
					"indices":7,
					"material":1
				},
				{
					"attributes":{
						"POSITION":8,
						"NORMAL":9,
						"TEXCOORD_0":10
					},
					"indices":11,
					"material":2
				}
			]
		}
	],
	"accessors":[
		{
			"bufferView":0,
			"componentType":5126,
			"count":806,
			"max":[
				3.38694429397583,
				2.2784509658813477,
				1.8925631046295166
			],
			"min":[
				-2.3379344940185547,
				-8.654031753540039,
				-1.9226858615875244
			],
			"type":"VEC3"
		},
		{
			"bufferView":1,
			"componentType":5126,
			"count":806,
			"type":"VEC3"
		},
		{
			"bufferView":2,
			"componentType":5126,
			"count":806,
			"type":"VEC2"
		},
		{
			"bufferView":3,
			"componentType":5123,
			"count":1284,
			"type":"SCALAR"
		},
		{
			"bufferView":4,
			"componentType":5126,
			"count":670,
			"max":[
				1.4786350727081299,
				0.8900154829025269,
				0.9012901782989502
			],
			"min":[
				-0.6556226015090942,
				-0.9902045726776123,
				-1.224705457687378
			],
			"type":"VEC3"
		},
		{
			"bufferView":5,
			"componentType":5126,
			"count":670,
			"type":"VEC3"
		},
		{
			"bufferView":6,
			"componentType":5126,
			"count":670,
			"type":"VEC2"
		},
		{
			"bufferView":7,
			"componentType":5123,
			"count":948,
			"type":"SCALAR"
		},
		{
			"bufferView":8,
			"componentType":5126,
			"count":52,
			"max":[
				1.4095723628997803,
				0.8454731702804565,
				0.8828020095825195
			],
			"min":[
				-0.622162938117981,
				-0.951306939125061,
				-1.216944694519043
			],
			"type":"VEC3"
		},
		{
			"bufferView":9,
			"componentType":5126,
			"count":52,
			"type":"VEC3"
		},
		{
			"bufferView":10,
			"componentType":5126,
			"count":52,
			"type":"VEC2"
		},
		{
			"bufferView":11,
			"componentType":5123,
			"count":72,
			"type":"SCALAR"
		}
	],
	"bufferViews":[
		{
			"buffer":0,
			"byteLength":9672,
			"byteOffset":0,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":9672,
			"byteOffset":9672,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":6448,
			"byteOffset":19344,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2568,
			"byteOffset":25792,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":8040,
			"byteOffset":28360,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":8040,
			"byteOffset":36400,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":5360,
			"byteOffset":44440,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1896,
			"byteOffset":49800,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":624,
			"byteOffset":51696,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":624,
			"byteOffset":52320,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":416,
			"byteOffset":52944,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":144,
			"byteOffset":53360,
			"target":34963
		}
	],
	"buffers":[
		{
			"byteLength":53504,
			"uri":"big_boss_hit2.bin"
		}
	]
}
